export default __webpack_public_path__ + "static/media/gifphy.fa368f65.gif";